<template>
    <Modal v-model="modelShow" title="查看仓库(只读)" width="650">
        <Form label-position="right" :model="storage" :label-width="100 " inline>
            <Divider v-if="contactShow" orientation="left">仓库详情信息</Divider>
            <FormItem label="联系人">
                <Input v-model="storage.linkmanName" readonly style="width:180px" />
            </FormItem>
            <FormItem label="仓库名称">
                <Input v-model="storage.name" readonly style="width:180px" />
            </FormItem>
            <br />
            <FormItem label="仓库类型">
                <Input v-model="storage.type" readonly style="width:180px" />
            </FormItem>
            <FormItem label="仓库所在区域">
                <Input v-model="storage.areaId" readonly style="width:180px" />
            </FormItem>
            <br />
            <FormItem label="仓库地址">
                <Input v-model="storage.address" readonly style="width:468px" />
            </FormItem>
            <br />
            <template v-if="contactShow">
                <Divider orientation="left">联系人详情信息</Divider>
                <FormItem label="联系人">
                    <Input v-model="memberContact.name" readonly style="width:180px" />
                </FormItem>
                <FormItem label="手机号">
                    <Input v-model="memberContact.mobile" readonly style="width:180px" />
                </FormItem>
                <br />
                <FormItem label="邮箱">
                    <Input v-model="memberContact.email" readonly style="width:180px" />
                </FormItem>
                <FormItem label="证件号码">
                    <Input v-model="memberContact.identityNo" readonly style="width:180px" />
                </FormItem>
            </template>
        </Form>
        <template #footer>
            <Button type="primary" @click="close">关闭</Button>
        </template>
    </Modal>
</template>

<script>
export default {
    props: {
        contactShow: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            modelShow: false,
            storage: {},
            memberContact: {}
        }
    },
    methods: {
        openModal(storageId) {
            this.modelShow = true
            let data = {
                url: 'CORE-STORAGE/messageService/baseInfoService/queryStorageBaseInfo',
                body: { storageId }
            }
            this.invoke(data).then(res => {
                if (res) {
                    this.storage = res
                    if (this.contactShow) {
                        this.getContact(res.linkmanId)

                    }
                    let storage = this.dict.initDict([{ id: 'storageBaseInfo.StorageType', namespace: 'ENUM_CORE-STORAGE' }, { id: 'fullArea', namespace: 'region' }]); // 初始化字典
                    this.storage.type = this.$options.filters['queryDict']('ENUM_CORE-STORAGE', 'storageBaseInfo.StorageType', this.storage.type)
                    this.storage.areaId = this.$options.filters['queryDict']('region', 'fullArea', this.storage.areaId)
                }
            })
        },
        getContact(id) {
            let data = {
                url: 'CORE-MEMBER/messageService/contactService/queryContact',
                body: { id }
            }
            this.invoke(data).then(res => {
                if (res) {
                    this.memberContact = res
                }
            })
        },
        close() {
            this.modelShow = false
        }
    }

}
</script>